import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { getIsClientInitialized } from './globalStore';

export const DIBootstrap: FC = ({ children }) => {
  const isClientInitialized = useSelector(getIsClientInitialized);
  return isClientInitialized ? <>{children}</> : null;
};
